// Элементы, которые исключаем из подсчёта
const excludeElements = [
    '.hh-embed-video-wrapper',
    '.hh-content-embed-post-small',
    '.wp-caption',
    '.wp-caption-text',
    'ul',
    '.hh-highlighted-block-v3',
    '.hh-highlighted-block-v2',
    'iframe',
    '.instagram-media-registered',
];
const minTextLengthWords = 450; // Минимальная длина текста, где будет вставка блока
const minElementHeight = 150; // Минимальная высота элемента для вставки баннера
const banners = [];

$(document).ready(() => {
    if (! $('.js-post-content-for-donation-block').length) {
        return false;
    }

    // Инициализация данных для баннеров
    const getDataBannerFond = () => {
        const bannerData = getRandomArrayItem(HH.fond_banners_cache);

        const fond_url = hh_set_utm_params(
            bannerData.url,
            'www.pravmir.ru',
            'site-widget',
            'fond-single-cause-widget--article-content',
            '',
            ''
        );

        return {
            align: 'center',
            is_layout_small: true,
            is_layout_fullwidth: false,

            title: bannerData.title,
            url: fond_url,
            thumbnail_src: bannerData.banner_in_content_src,
            thumbnail_alt: bannerData.title,

            is_audio: false,
            is_video: false,
            is_photo: false,
        };
    };

    const getDataBannerPravmir = () => {
        return {};
    };

    banners.push(
        {
            id: 'hh-donation-block-in-content--pravmir',
            data: getDataBannerPravmir(),
        },
        {
            id: 'hh-donation-block-in-content--fond',
            data: getDataBannerFond(),
        },
    );

    const bannersList = getBanners(banners); // Получаем все баннеры

    // Проходимся по баннерам и выводим их в шаблон
    let renderedBanner;
    bannersList.forEach((banner) => {
        renderedBanner = Mustache.render(banner.template, banner.data); // Рендерим

        if (banner.name === 'hh-donation-block-in-content--fond') {
            // const fondBanner_element_for_slice = getSliceElement(); // Определяем место для вставки баннера
            // $(fondBanner_element_for_slice).before(renderedBanner); // Вставляем в шаблон
            $('.hh-donation-block-in-content_after-content').append(renderedBanner); // Вставляем в конец контента
        }

        if (banner.name === 'hh-donation-block-in-content--pravmir') {
            const pravmirBanner_element_for_slice = getSliceElement(50, true, 150);

            $(pravmirBanner_element_for_slice).before(renderedBanner); // Вставляем в шаблон
        }
    })

    $(document).on('click', '.js-post-donation-block__link', function () {
        hh_send_counter_target('hh-post-donation-block__click');
    });
});

const getRandomArrayItem = (list) => {
    return list[Math.floor(Math.random() * list.length)]
};

// Получение готовых баннеров с версткой
const getBanners = (banners) => {
    let rendered_template_list = [];

    banners.forEach((banner, index) => {
        const template = document.getElementById(banner.id);

        if (!template) {
            return true;
        }

        rendered_template_list.push(
            {
                name: banner.id,
                data: banner.data,
                template: template.innerHTML,
            }
        );
    });

    return rendered_template_list;
};

const getWordCountByElement = (element) => {
    const content_text = $(element).text();

    return content_text.trim().split(/\s+/).length;
};

// Определение, является ли элемент вопросом интервью
const elementIsInterviewQuestion = (element) => {
    return ($(element).find('b').length
        ||
        $(element).find('strong').length
        ||
        $(element).css('font-weight') === 'bold'
        ||
        $(element).css('font-weight') == 700);
};

const elementIsBad = (element) => {

    return (
        $(element).find('img.size-full').length
        ||
        $(element).is('blockquote')
        ||
        $(element).is('.hh-highlighted-block-v3')
        ||
        $(element).is('.hh-highlighted-block-v2')
    );
};

// Имеет ли элемент свободное пространство для вставки блока?
const elementNotFreeSpace = (element, nextElement) => {
    const heightElement = $(element).height();
    const displayStyle = $(element).css('display');

    // Если есть следующий элемент, который может предоставить свободное место баннеру
    if (heightElement < minElementHeight
        && $(element).next().is($(nextElement))
        && displayStyle !== 'inline'
        && $(nextElement).css('display') !== 'inline'
    ) {
        return false;
    }

    if (heightElement <= minElementHeight && displayStyle !== 'inline') {
        console.log('Donation block incorrect inserting');
        return true;
    }

    return false;
}

// Получение тега, на границе процента контента
const getSliceElement = (percent = 25, simple = false, minTextLengthWordsFunc = minTextLengthWords) => {

    const all_tags_in_content = $('.js-post-content-for-donation-block').children().not(excludeElements.join(','));
    const all_text_word_count = all_tags_in_content.text().trim().split(/\s+/).length;

    if (all_text_word_count < minTextLengthWordsFunc) {
        return;
    }

    const slice_word_number =  Math.round(all_text_word_count * (percent / 100));
    let word_count_sum = 0;
    let slice_element;

    // Проходимся по всем тегам.
    // Считаем, сколько в теге слов и добавляем их к счётчику. Когда счётчик стал больше расчётного, то
    // выходим из цикла и возвращаем тег после которого будет вставлен баннер
    all_tags_in_content.each((index, element) => {
        word_count_sum += getWordCountByElement(element);

        if (word_count_sum < slice_word_number) { // Переходим к следующему шагу сразу, пока не набрано необходимое количество. Для оптимизации.
            return true;
        }

        // Начало условий. Баннер готов к вставке. Теперь проходимся по условиям, чтобы не вставлять его некорректно

        // Если простая вставка (элемент на всю ширину и не требуется проверки корректности)
        if (simple) {
            slice_element = element;

            return false;
        }

        if (elementIsInterviewQuestion(element)) { // Пропускаем интервью
            return true;
        }

        else if (elementIsBad(element)) { // Пропускаем, если следующий элемент не подходящий
            return true;
        }

        else if (elementNotFreeSpace(element, all_tags_in_content[index + 1])) { // Пропускаем, если следующий элемент не имеет достаточно места для обтекания баннера
            return true;
        }
        // Конец условий. Баннер можно корректно вставить в нужное место

        else if (word_count_sum > slice_word_number) { // Выходим из цикла
            slice_element = element; // Вставляем перед следующим элементом. Для того, чтобы учитывать только те элементы, которые в нашем списке

            return false;
        }
    });

    return slice_element;
};

const choiceBanner = (banners) => {
    return banners[1]; // Баннер фонда

    // const random_number = Math.floor(Math.random() * Math.floor(100));
    //
    // if (random_number >= 40) {
    //     return banners[1]; // Баннер фонда
    // }
    //
    // return banners[0]; // Баннер Правмира
};
